import React, { Component } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse/index'

import removeActiveRoom from '../../../actions/removeActiveRoomActions'
import removeActiveEnhancement from '../../../actions/removeActiveEnhancementActions'
import manageMultiRoom from '../../../actions/multiRoomActions'
import setActiveStep from '../../../actions/activeStepActions'

import BkFlowCurrencyToggle from '../../currency/BkFlowCurrencyToggle'
import BkFlowNavigationDetailsEntry from './elements/BkFlowNavigationDetailsEntry'
import BkFlowNavigationDetailsLocationSidebar from './elements/BkFlowNavigationDetailsLocationSidebar'

// GA events handler
import triggerCustomGaEvent from '../../../utilities/analytics/triggerCustomGaEvent'

import '../../../styles/css/components/navigation/bk-flow-navigation-details.css'

import _ from 'lodash'
import yn from 'yn'

class BkFlowNavigationDetails extends Component {

	constructor(props) {
		super(props)
		this.state = {
			detailsExpanded: this.props.detailsExpanded
		}
	}

	renderDetailsAccordion() {
		const {
			configData,
			urlData,
			multiRoomData,
			availabilityData,
			activeRoom,
			activeEnhancementData,
			activeStep,
			activeCurrencyData,
			detailsExpanded,
			handleRemoveActiveRoom,
			handleRemoveEnhancement,
			handleEditRoom,
			handleUpdateStep
		} = this.props

		// Window.session data for guests / pets
		let flowGuestData = null

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		// Init room structures
		let renderDetailsEntries = [],
				activeHotelCode = null,
				activePropertyNumbers = null,
				activePropertyEmails = null,
				activePropertyAddressData = null

		// Get hotel code from avail response
		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers
			) {
				activePropertyNumbers = matchedProperty.contactNumbers
			}

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactEmails
			) {
				activePropertyEmails = matchedProperty.contactEmails
			}

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.address
			) {
				activePropertyAddressData = matchedProperty.address
			}
		}

		// Build rooms entries
		if (multiRoomData.isMultiRoom) {
			// Individual entries
			for (let i = 0; i < multiRoomData.multiRoomTotal; i++) {
				if (activeRoom[i]) {
					renderDetailsEntries.push(
						<BkFlowNavigationDetailsEntry
							key={i}
							currentRoomKey={i}
							configData={configData}
							urlData={urlData}
							activeStep={ activeStep }
							flowGuestData={ flowGuestData }
							activeRoomData={activeRoom}
							currentRoom={activeRoom[i]}
							activeEnhancementData={activeEnhancementData}
							multiRoomData={multiRoomData}
							editRoomEvent={handleEditRoom}
							removeRoomEvent={handleRemoveActiveRoom}
							editStepEvent={handleUpdateStep}
							removeEnhancementEvent={handleRemoveEnhancement}
						/>
					)
				}
			}
		} else {
			renderDetailsEntries.push(
				<BkFlowNavigationDetailsEntry
					key={0}
					currentRoomKey={0}
					configData={configData}
					urlData={urlData}
					activeStep={ activeStep }
					flowGuestData={ flowGuestData }
					activeRoomData={activeRoom}
					currentRoom={activeRoom[0]}
					activeEnhancementData={activeEnhancementData}
					multiRoomData={multiRoomData}
					editRoomEvent={handleEditRoom}
					removeRoomEvent={handleRemoveActiveRoom}
					editStepEvent={handleUpdateStep}
					removeEnhancementEvent={handleRemoveEnhancement}
				/>
			)
		}

		return  (
			<Collapse
				className={ detailsExpanded ?
					'bk-flow-navigation-details__accordion active'
				:
					'bk-flow-navigation-details__accordion'
				}
				in={ detailsExpanded }
				timeout={ 300 }
			>
				<div className="u-container">
					<div className="bk-flow-navigation-details__content">
						<div
							className={ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DETAILS_LOCATION) ?
								'bk-flow-navigation-details__entries include-sidebar'
							:
								'bk-flow-navigation-details__entries'
							}
						>
							{ renderDetailsEntries }
						</div>

						{ yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
							yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DETAILS_MOBILE_CURRENCY_TOGGLE) &&
							activeCurrencyData &&
							activeCurrencyData.exchangeRate &&
							<div className="bk-flow__currency-toggle-mobile">
								<BkFlowCurrencyToggle
									isMobile={ true }
									displayLabel={ true }
								/>
							</div>
						}

						{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DETAILS_LOCATION) &&
							<BkFlowNavigationDetailsLocationSidebar
								configData={configData}
								availabilityData={availabilityData}
								propertyNumbers={activePropertyNumbers}
								propertyAddress={activePropertyAddressData}
								propertyEmails={activePropertyEmails}
							/>
						}
					</div>
				</div>
			</Collapse>
		)
	}


	render() {
		return this.renderDetailsAccordion()
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		multiRoomData: state.multiRoomData,
		urlData: state.availabilityData.urlData,
		availabilityData: state.availabilityData.availability,
		activeRoom: state.activeRoomData,
		activeEnhancementData: state.activeEnhancementData,
		activeStep: state.activeStepData.activeStep,
		activeCurrencyData: state.activeCurrencyData,
	}
}

const mapDispatchToProps = dispatch => ({
	handleEditRoom(activeStep, newRoomStep, multiRoomData) {
		let updatedActiveStep = activeStep

		// Account for preRes services component changing step order
		if (process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS && activeStep === 2) {
			updatedActiveStep = activeStep - 2
		} else if (activeStep > 0) {
			updatedActiveStep = activeStep - 1
		}

		function handleEditMultiRoom() {
			if (multiRoomData.isMultiRoom) {
				return dispatch(manageMultiRoom(multiRoomData.isMultiRoom, multiRoomData.multiRoomTotal, newRoomStep))
			} else {
				return
			}
		}

		return (
			dispatch(setActiveStep(updatedActiveStep)),
			handleEditMultiRoom()
		)
	},
	handleRemoveActiveRoom(currentActiveRooms, roomKey, multiRoomData) {
		let isMultiRoom = multiRoomData.isMultiRoom,
				updatedMultiFlag = null,
				multiRoomTotal = multiRoomData.multiRoomTotal,
				updatedMultiTotal = null,
				updatedMultiStep = multiRoomData.currentMultiRoomStep

		if (multiRoomTotal > 1) {
			updatedMultiTotal = multiRoomTotal - 1
		} else {
			updatedMultiTotal = multiRoomTotal
		}

		if (multiRoomTotal <= 2) {
			updatedMultiFlag = false
		} else {
			updatedMultiFlag = isMultiRoom
		}

		// Handle immutable room object
		function deleteActiveRoom(state, id) {
			let newState = Object.assign({}, state),
					indexedState = {},
				  i = 0

			// Remove activeRoom entry by ID
			delete newState[id]

			// Remap newState
			for (let keys in newState) {
				indexedState[i] = newState[keys]
				i++
			}

			return indexedState
		}

		// Dispatch initial GA events
		let removedRoomData = {
			roomGroup: roomKey,
			roomType: currentActiveRooms[roomKey]
		}

		triggerCustomGaEvent('analytics-roomRemoved', removedRoomData)

		// Updated activeRooms
		const updatedActiveRooms = deleteActiveRoom(currentActiveRooms, roomKey)

		return (
			dispatch(manageMultiRoom(updatedMultiFlag, updatedMultiTotal, updatedMultiStep)),
			dispatch(removeActiveRoom(updatedActiveRooms))
		)
	},
	handleRemoveEnhancement(activeEnhancements, enhancementKey) {
		// Dispatch activeRoom GA events
		triggerCustomGaEvent('analytics-removeService', enhancementKey)

		return dispatch(removeActiveEnhancement(enhancementKey))
	},
	handleUpdateStep(activeStep) {
		return dispatch(setActiveStep(activeStep))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowNavigationDetails)


// WEBPACK FOOTER //
// ./src/components/structure/navigation/BkFlowNavigationDetails.js